var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mobile-menu-main-link-button" }, [
      _c(
        "div",
        {
          staticClass: "mobile-menu-main-link-button-container",
          on: { click: _vm.OpenSubMenuMobile }
        },
        [
          !_vm.block.show_mega_menu
            ? _c(
                "a",
                {
                  staticClass: "h5 mobile-menu-main-link-button-text",
                  attrs: { href: _vm.block.url }
                },
                [_vm._v(_vm._s(_vm.block.title))]
              )
            : _c("h5", { staticClass: "mobile-menu-main-link-button-text" }, [
                _vm._v(_vm._s(_vm.block.title))
              ]),
          _vm.block.show_mega_menu
            ? _c("icon", { attrs: { name: "chevron-right", size: "16px" } })
            : _vm._e()
        ],
        1
      ),
      _c("hr", { staticClass: "mobile-menu-main-link-button-line" }),
      _vm.block.show_mega_menu
        ? _c(
            "div",
            {
              staticClass: "mobile-panel",
              class: { open: _vm.showSubMenuMobile }
            },
            [
              _c(
                "div",
                {
                  staticClass: "mobile-panel-title",
                  on: { click: _vm.closeSubMenuMobile }
                },
                [
                  _c("icon", {
                    staticClass: "mobile-panel-title-icon",
                    attrs: { name: "chevron-left", size: "16px" }
                  }),
                  _c("h4", { staticClass: "mobile-panel-title-icon-text" }, [
                    _vm._v(_vm._s(_vm.block.title))
                  ]),
                  _c("div", {
                    staticClass: "mobile-panel-title-icon-invisible-item"
                  })
                ],
                1
              ),
              _c(
                "accordion-group",
                { staticClass: "navbar__mobile__linklist" },
                _vm._l(_vm.links, function(link, index) {
                  return _c(
                    "navbar-mobile-accordion",
                    {
                      key: index,
                      staticClass:
                        "navbar__mobile__category nav-main-links-container accordionClass",
                      attrs: {
                        blockType: _vm.blockType,
                        heading: link.title,
                        headinglink: link.url
                      }
                    },
                    _vm._l(link.children, function(subMenuItems, i) {
                      return _c(
                        "div",
                        { key: i, staticClass: "header__dropdown-list-item" },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-link link link--primary",
                              attrs: { href: subMenuItems.url }
                            },
                            [_vm._v(_vm._s(subMenuItems.title))]
                          )
                        ]
                      )
                    }),
                    0
                  )
                }),
                1
              ),
              _vm.$mq === "desktop"
                ? _c("div", { staticClass: "mobile-panel__link-container" }, [
                    _vm.block.large_image_link_text
                      ? _c(
                          "a",
                          {
                            staticClass: "mobile-panel__link",
                            attrs: { href: _vm.block.large_image_link }
                          },
                          [_vm._v(_vm._s(_vm.block.large_image_link_text))]
                        )
                      : _vm._e(),
                    _vm.block.image_1_text
                      ? _c(
                          "a",
                          {
                            staticClass: "mobile-panel__link",
                            attrs: { href: _vm.block.image_1_url }
                          },
                          [_vm._v(_vm._s(_vm.block.image_1_text))]
                        )
                      : _vm._e(),
                    _vm.block.image_2_text
                      ? _c(
                          "a",
                          {
                            staticClass: "mobile-panel__link",
                            attrs: { href: _vm.block.image_2_url }
                          },
                          [_vm._v(_vm._s(_vm.block.image_2_text))]
                        )
                      : _vm._e(),
                    _vm.block.image_3_text
                      ? _c(
                          "a",
                          {
                            staticClass: "mobile-panel__link",
                            attrs: { href: _vm.block.image_3_url }
                          },
                          [_vm._v(_vm._s(_vm.block.image_3_text))]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }